import React, { useState, useEffect } from 'react';
import { Dialog } from '@mui/material';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { useWizard } from '../../../../../../components/wizard/WizardContext';
import { fetchReceiptDetails } from '../utils';
import ALoader from '../../../../../../views/pages/manage/common/a-loader';
import ADataGrid from '../../../../../../views/pages/manage/common/data-grid/ADataGrid';
import { gridComponents, gridStyles } from '../../../../../../views/pages/manage/edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import NoRowOverlay from '../../../../../../views/pages/manage/masters/holidayMaster/NoRowOverlay';
import { AGridColDef } from '../../../../../../views/pages/manage/common/data-grid/ADataGridColDef';
import styles from "../../styles.module.scss";
import { formattedPrice } from '../../../../../../views/pages/manage/unAssigned/collectPayment/utils';


const ViewReceiptDetailsDialog = ({
    dialogInfo = {},
    setDialogInfo,
}) => {

    const [receiptDetails, setReceiptDetails] = useState({
        loading: false,
        data: []
    })

    const { values } = useWizard();

    const { selectedStudent } = values;

    const { isOpen, receiptId } = dialogInfo;

    const columns = [
        new AGridColDef("paymode", "Paymode", false)
            .setMinWidth(90)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter((params) => params?.value),

        new AGridColDef("itemType", "Item Type", true)
            .setMinWidth(90)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter((params) => params?.value),

        new AGridColDef("description", "Description", false)
            .setMinWidth(90)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter((params) => params?.value),

        new AGridColDef("receiptDate", "Receipt Date", true)
            .setMinWidth(90)
            .setFlex(0.8)
            .editable(true)
            .setValueGetter((params) => params?.value),

        new AGridColDef("itemAmount", "Payment mode amount", false)
            .setMinWidth(90)
            .setFlex(0.8)
            .editable(true)
            .renderCellComponent((params) => <div className={styles['amount']}>{formattedPrice(params?.value)}</div>),
    ]

    const fetchData = async () => {
        try {
            setReceiptDetails(prev => ({ ...prev, loading: true }));
            const data = await fetchReceiptDetails(receiptId, selectedStudent);
            setReceiptDetails(prev => ({...prev , data}));
        } catch (err) {
            console.error(err);
        } finally {
            setReceiptDetails(prev => ({ ...prev, loading: false }));
        }
    }

    useEffect(() => {
        receiptId && fetchData();
    }, [receiptId])


    return (
        <Dialog
            open={isOpen}
            fullWidth
            maxWidth="md"
        >
            {receiptDetails?.loading && <ALoader position="fixed" />}
            <div className='p-3'>

                <div className='d-flex justify-content-between'>
                    <h3>Receipt No {`(${receiptId})`}</h3>
                    <CrossIcon onClick={() => setDialogInfo({})} />
                </div>

                <ADataGrid
                    removeWrapperContainer
                    rows={receiptDetails?.data || []}
                    columns={columns}
                    rowId={(row) => JSON.stringify(row)}
                    rowHeight={50}
                    loading={false}
                    components={{
                        ...gridComponents,
                        NoRowsOverlay: () => (
                            <NoRowOverlay message={receiptDetails?.loading ? "Loading..." : null} />
                        ),
                    }}
                    sx={gridStyles}
                    hidePagination
                />


            </div>

        </Dialog>
    );
}

export default ViewReceiptDetailsDialog;